import price from './price';
import dictionary from './dictionary';

export default {
    price,
    dictionary
}
